module.exports = "/fonts/hashed/NotoSansKR-Medium.67d15826.ttf.gz.bin";